import { createContext } from 'react'

export let FormTypeContext = createContext<string | undefined>(undefined)
